import { useState } from "react";
import CalculateExpense from "../components/CalculateExpense";

const CalculationPage = () => {
    const [expenses, setExpenses] = useState([]);

    return <CalculateExpense expenses={expenses} />;
};

export default CalculationPage;
